import script from "./Reports.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reports.vue?vue&type=script&setup=true&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=47dbf45a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47dbf45a"]])

export default __exports__